import React, { useState, useEffect } from "react";
import ModalContainer from "../ModalContainer";
import { Container, Stack, Checkbox, FormControlLabel, Divider, Box, Typography } from "@mui/material";
import { CONTROL_MEASURES } from "../../../constants";
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ModalButton from "../Buttons/normal/ModalButton";
import Colors from "../../../colors";
import AddIcon from '@mui/icons-material/Add';
import { toTitleCase } from "../../../utils/helpers";

function CorrelatedControlsModal({
    name, isSelected,
    isVisible, setIsVisible,
    checkedControlMeasures, correlatedControlMeasures,
    saveButtonOnClickHandler, removeButtonOnClickHandler }) {
    const [customMeasureText, setCustomMeasureText] = useState('');
    const [error, setError] = useState(false);
    const [tempCheckedControlMeasures, setTempCheckedControlMeasures] = useState(checkedControlMeasures);
    const [tempCorrelatedControlMeasures, setTempCorrelatedControlMeasures] = useState(correlatedControlMeasures);

    useEffect(() => {
        setTempCheckedControlMeasures(checkedControlMeasures);
        setTempCorrelatedControlMeasures(correlatedControlMeasures);
        // eslint-disable-next-line
    }, [isVisible]);

    const handleControlMeasureClick = (event) => {
        const clickedControlMeasure = event.target.name;
        setTempCheckedControlMeasures(prev => {
            if (prev.includes(clickedControlMeasure)) {
                return prev.filter(cm => cm !== clickedControlMeasure);
            } else {
                return [...prev, clickedControlMeasure];
            }
        });
        // event.target.checked = !event.target.checked;
    };

    const addCustomCorrelatedMeasure = () => {
        if (customMeasureText.trim().length === 0) {
            setError(true);
            setTimeout(() => {
                setError(false);
            }, 2000)
        } else {
            const titleCasedCM = toTitleCase(customMeasureText);
            setTempCorrelatedControlMeasures(prev => ([...prev, titleCasedCM]));
            setTempCheckedControlMeasures(prev => ([...prev, titleCasedCM]));
            setCustomMeasureText('');
        }
    };

    const styles = {
        controlMeasure: {
            display: 'flex',
            alignItems: 'center',
            marginRight: '10px',
            marginBottom: '5px',
            borderRadius: '8px',
            paddingLeft: '8px',
            border: '1px solid var(--green)',
            boxShadow: '0px 4px 15px rgba(62, 164, 72, 0.1)'
        },
        customControlMeasure: {
            height: '51px',
            padding: '5px',
            backgroundColor: Colors.white,
        },
        customInput: {
            border: error ? '2px solid red' : Colors.white,
            width: '100%',
            height: '41px',
            fontFamily: 'Jost',
            fontSize: '1.1rem',
            marginRight: '6px',
        },
        plusIconContainer: {
            marginLeft: 'auto',
            display: 'flex',
            borderRadius: '50%',
            background: Colors.green,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.12)',
        },
        modalButtonContainer: {
            display: 'flex',
            width: '75%',
            marginBottom: '20px'
        }
    };

    return (
        <ModalContainer
            isVisible={isVisible}
            setIsVisible={setIsVisible} >
            <Container sx={{
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <h3>Hazard:<br />{name}</h3>
                <span style={{ fontSize: '1.1rem' }}>{`Select the ${CONTROL_MEASURES} in place:`}</span>
                <Divider />
                <Stack sx={{
                    marginTop: '5px',
                    marginBottom: '30px',
                    maxHeight: '300px',  // Set a fixed height
                    overflowY: 'auto',  // Enable vertical scrolling
                    width: '100%',
                }}>
                    {tempCorrelatedControlMeasures.map((row) => (
                        <Box
                            key={row}
                            style={{
                                ...styles.controlMeasure,
                                backgroundColor: tempCheckedControlMeasures.includes(row) ? Colors.lightGreen : Colors.white,
                            }} >
                            <FormControlLabel
                                control={<Checkbox
                                    sx={{ marginRight: '5px' }}
                                    name={row}
                                    checked={tempCheckedControlMeasures.includes(row)}
                                    icon={<CircleOutlinedIcon sx={{ color: Colors.green, fontSize: 30 }} />}
                                    checkedIcon={<CheckCircleOutlineOutlinedIcon sx={{ backgroundColor: Colors.green, color: 'white', borderRadius: '50%', fontSize: 30 }} />}
                                    onClick={handleControlMeasureClick} />}
                                label={<Typography
                                    sx={{ fontSize: '1.1rem', fontFamily: 'Jost' }}>
                                    {row}
                                </Typography>}
                            />
                        </Box>
                    ))}
                    <Box sx={{
                        ...styles.customControlMeasure,
                        ...styles.controlMeasure,
                    }} >
                        <input
                            style={styles.customInput}
                            type="text"
                            placeholder={'Enter custom Control Measure'}
                            value={customMeasureText}
                            onChange={(e) => setCustomMeasureText(e.target.value)} />
                        <Box
                            sx={styles.plusIconContainer}
                            onClick={addCustomCorrelatedMeasure} >
                            <AddIcon sx={{ fontSize: 28, color: Colors.white }} />
                        </Box>
                    </Box>
                </Stack>
                {isSelected && <Box sx={styles.modalButtonContainer} >
                    <ModalButton
                        color={Colors.red}
                        onClick={removeButtonOnClickHandler}
                        children={'Remove this Hazard?'} />
                </Box>}
                <Box sx={styles.modalButtonContainer} >
                    <ModalButton
                        color={Colors.green}
                        onClick={() => saveButtonOnClickHandler(tempCheckedControlMeasures, tempCorrelatedControlMeasures)}
                        children={'Save & Close'} />
                </Box>
            </Container>
        </ModalContainer>
    );
}

export default CorrelatedControlsModal;